export default __webpack_public_path__ + "static/media/WAN.85acb38b.jpg";